/**
 * This function is used especifically for Dialog components that has multiple pages (it doesnt support window.scrollTo)
 * @param refElement useRef object
 */
export const scrollToTopDialog = (
  refElement: React.RefObject<HTMLDivElement>,
): void => {
  if (refElement.current !== null) {
    refElement.current.scrollIntoView();
  }
};

export default scrollToTopDialog;
